import React from 'react';
import styles from './EntityItem.module.scss';
import VariablesPanel from '../variables-panel/VariablesPanel';
import Button from 'component/atom/forms/button/Button';

const EntityItem = ({
  item,
  label,
  index,
  formik,
  typeOptions,
  openIndex,
  setOpenIndex,
}) => {
  const isOpen = openIndex === index;

  return (
    <>
      <div className={styles['entity-item']}>
        <p
          className={styles['entity-label']}
          onClick={(e) => {
            e.stopPropagation();
            setOpenIndex(isOpen ? null : index);
          }}
        >
          {label}
        </p>
        <Button
          type='delete'
          variant='danger'
          onClick={(e) => {
            e.stopPropagation();
            const next = formik.values.suggestedEntityQuestions.filter(
              (_, i) => i !== index,
            );
            formik.setFieldValue('suggestedEntityQuestions', next);
            if (isOpen) setOpenIndex(null);
          }}
          className={styles['remove-button']}
        />
      </div>
      <VariablesPanel
        open={isOpen}
        onClose={() => setOpenIndex(null)}
        index={index}
        formik={formik}
        typeOptions={typeOptions}
      />
    </>
  );
};

export default EntityItem;
